// static levels data

const baseUrl = "";

export default {
  classic: {
    genre: "Classic",
    title: "Элементарно",
    backgroundImage: baseUrl + "images/bgs/classic.jpg",
    headphoneImage: baseUrl + "images/white.png",
    backgroundSoundKey: "bgClassic",

    tapValue: 1,
    maxScore: 10,
  },

  jazz: {
    genre: "jazz",
    title: "Легко",
    backgroundImage: baseUrl + "images/bgs/jazz.jpg",

    headphoneImage: baseUrl + "images/pink.png",
    backgroundSoundKey: "bgJazz",

    tapValue: 1,
    maxScore: 20,
  },

  rock: {
    genre: "rock",
    title: "Непросто",
    backgroundImage: baseUrl + "images/bgs/rock.jpg",

    headphoneImage: baseUrl + "images/blue.png",
    backgroundSoundKey: "bgRock",

    tapValue: 1,
    maxScore: 30,
  },

  pop: {
    genre: "pop",
    title: "Сложно",
    backgroundImage: baseUrl + "images/bgs/pop.jpg",
    headphoneImage: baseUrl + "images/grey.png",
    backgroundSoundKey: "bgPop",

    tapValue: 1,
    maxScore: 40,
  },

  rap: {
    genre: "rap",
    title: "Очень сложно",
    backgroundImage: baseUrl + "images/bgs/rap.jpg",
    headphoneImage: baseUrl + "images/gold.png",
    backgroundSoundKey: "bgRap",

    tapValue: 1,
    maxScore: 50,
  },

  metal: {
    genre: "metal",
    title: "Невозможно",
    backgroundImage: baseUrl + "images/bgs/metal.jpg",
    headphoneImage: baseUrl + "images/black.png",
    backgroundSoundKey: "bgMetal",

    tapValue: 1,
    maxScore: 60,
  },
};
